/**
 * Dependencies.
 */
import { ResultModel } from '@/api/result/result.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import DeliveryModel from './delivery.model';

/**
 * Service `DeliveryService`.
 */
class DeliveryService extends BaseService<DeliveryModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      DeliveryModel,
      DeliveryModel.name,
      applicationConstant.apiDriverDCPrivateUrl
    );
  }

  /**
   * Validate code.
   */
  validateCode(code: string): Promise<ResultModel> {
    const endpoint = `${this.getModelEndpoint}/${code}/validate`;

    return this.GET(endpoint);
  }
}

/**
 * Export `deliveryService`.
 */
export const deliveryService = new DeliveryService();
